/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'production-queue': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<circle pid="0" cx="10.2" cy="4.7" r=".5"/><path pid="1" d="M10 0C4.478 0 0 4.477 0 10s4.478 10 10 10 10-4.477 10-10S15.522 0 10 0zM7.561 13.886l-.965.965-.707-.707.404-.404-.793-.751-.793.75.467.467-.707.707-1.027-1.027-.04-.147.039-.146.561-.561 1-.993v-.8s.281.125.5.125.5-.125.5-.125v.8l1 .993.561.561.039.146-.039.147zm-1.377-3.355c-.2.2-.46.31-.73.31-.239 0-.489-.1-.689-.279a.996.996 0 01-.03-1.41L8.1 5.576l.724.725.721.721-3.361 3.509zm9.847 1.555c-.384 0-.768-.146-1.061-.439l-6-6a1.5 1.5 0 112.121-2.121l6 6a1.5 1.5 0 01-1.06 2.56z"/>'
  }
})
